import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    currentStep: Number,
    totalSteps: Number
  }

  connect() {
    this.updateProgress()

    // Listen for turbo:frame-load to update progress when step changes
    this.element.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  handleFrameLoad(event) {
    // Update current step from data attribute (server updates it)
    this.currentStepValue = parseInt(this.element.dataset.registrationInvitationWizardCurrentStepValue)
    this.updateProgress()

    // Scroll to top of wizard
    this.element.scrollIntoView({ behavior: 'smooth', block: 'start' })

    // Focus on first input
    const turboFrame = this.element.querySelector('turbo-frame')
    if (turboFrame) {
      const firstInput = turboFrame.querySelector('input:not([type="hidden"]), select, textarea')
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100)
      }
    }
  }

  updateProgress() {
    // Update step circles
    this.updateStepCircles()
  }

  updateStepCircles() {
    // Progress indicator is now rendered server-side inside turbo frame
    // No need to update circles or connectors with JavaScript
    // They are updated automatically when the frame reloads
  }
}
